import type { AlternativeType } from "../../../../../common-deprecated/types/CommonTypes";

export const START_ETA_LOAD = "eta/startEtaLoad" as const;
export const FINISH_ETA_LOAD = "eta/finishEtaLoad" as const;
export const RESET_ETA = "eta/reset" as const;
export const INVALIDATE_ETA = "eta/invalidate" as const;
export const START_ETA_RATE_FETCH = "monthlyRate/startEtaRateFetch" as const;
export const FINISH_ETA_RATE_FETCH = "monthlyRate/finishEtaRateFetch" as const;

export type StartEtaLoadType = { type: typeof START_ETA_LOAD };
export type FinishEtaLoadType = {
    type: typeof FINISH_ETA_LOAD;
    eta: { date: string | false; alternatives: AlternativeType[] };
};
type ResetEtaType = { type: typeof RESET_ETA; isError: boolean };
type InvalidateEtaType = { type: typeof INVALIDATE_ETA };
export type StartEtaRateFetchType = { type: typeof START_ETA_RATE_FETCH };
type FinishEtaRateFetchType = { type: typeof FINISH_ETA_RATE_FETCH; result: AlternativeType[] };

export const startEtaLoad = (): StartEtaLoadType => ({ type: START_ETA_LOAD });
export const finishEtaLoad = (eta: { date: string | false; alternatives: AlternativeType[] }): FinishEtaLoadType => ({
    type: FINISH_ETA_LOAD,
    eta,
});
export const resetEta = (isError: boolean = false): ResetEtaType => ({ type: RESET_ETA, isError });
export const invalidateEta = (): InvalidateEtaType => ({ type: INVALIDATE_ETA });
export const startEtaRateFetch = (): StartEtaRateFetchType => ({ type: START_ETA_RATE_FETCH });
export const finishEtaRateFetch = (result: AlternativeType[]): FinishEtaRateFetchType => ({
    type: FINISH_ETA_RATE_FETCH,
    result,
});

export type EtaActionsType =
    | StartEtaLoadType
    | FinishEtaLoadType
    | ResetEtaType
    | InvalidateEtaType
    | StartEtaRateFetchType
    | FinishEtaRateFetchType;
